import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Article } from "@domain/lms/article/article";
import { useSuggestedArticles } from "@domain/lms/article/hooks";
import { useIsMobile } from "@utils/hooks";
import { ArticleThumbnailSmall } from "@ui/components/article/articleThumbnailSmall";
import { Carousel } from "@ui/components/carousel/carousel";
import { ArticleSeparator } from "@ui/pages/lms/article/articlePage/separator";

interface ArticleSuggestionsProps extends React.HTMLAttributes<HTMLDivElement> {
	source: Article;
}
export const ArticleSuggestions: React.FC<ArticleSuggestionsProps> = ({ source }) => {
	const { result: articles, loading } = useSuggestedArticles(10, source.category);
	const isMobile = useIsMobile();
	if (loading) return <ClipLoader />;
	const suggestions = articles.filter((art) => source.id !== art.id);
	return suggestions.length > 0 ? (
		<Container>
			<ArticleSeparator gapBottom />
			<StyledTitle>{I18n.t("seeAlso")}</StyledTitle>
			<Wrapper>
				<Carousel
					items={suggestions ?? []}
					renderItem={(article) => <ArticleThumbnailSmall forInsight key={article.id} article={article as Article} />}
					loading={loading}
					itemHeight={isMobile ? 485 : 460}
					itemWidth={310}
					// itemHeight={ isMobile ? 484  : 440}
					// itemWidth={310}
				/>
			</Wrapper>
		</Container>
	) : (
		<Container>
			<ArticleSeparator gapBottom />
		</Container>
	);
};

const StyledTitle = styled.div`
	color: ${({ theme }) => theme.colors.black};
	text-align: center;
	padding-bottom: 20px;
	font-family: Sora;
	font-style: normal;
	font-weight: 600;
	font-size: 21px;
	line-height: 26px;
`;

const Wrapper = styled.div`
	position: relative;
	//max-width: 1250px;
`;

const Container = styled.div`
	position: relative;
	display: block;
	flex: 1;
	overflow: visible;
`;
